import { render, staticRenderFns } from "./SwitchAccountPassword.vue?vue&type=template&id=bc429d8c&scoped=true"
import script from "./SwitchAccountPassword.vue?vue&type=script&lang=js"
export * from "./SwitchAccountPassword.vue?vue&type=script&lang=js"
import style0 from "./SwitchAccountPassword.vue?vue&type=style&index=0&id=bc429d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc429d8c",
  null
  
)

export default component.exports